<template>
  <div class="container">
    <el-image
      class="shadow-down banner"
      :src="require('@/assets/announce_banner.jpg')"
    ></el-image>
    <div class="content shadow-down">
      <div
        v-html="
           notice
        "
      ></div>
      <div style="text-align: right">
        <div
          style="
            display: inline-block;
            text-align: center;
            font-size: 16pt;
            font-family: 仿宋_GB2312;
            color:#333333
          "
        >
          <p>
            {{
              zgglk
            }}
          </p>
          <p>{{ noticeDate }}</p>
        </div>
      </div>
      <br />
      <div v-if="atta.length > 0">
        <h3>附件</h3>
        <ul style="list-style-type: none">
          <li v-for="item in atta" :key="item.guid">
            <a @click.stop.prevent="downloadAttachment(item)" href="#">{{
              item.filename
            }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div id="weixinTip" v-show="showWxtip"  @click="closewxtip">
      <img :src="require('@/assets/up.png')"  id="upimg"/>
      <p>
        <el-image :src="require('@/assets/i13.png')"></el-image>
        <span> 由于微信限制，请点击右上角，使用默认浏览器下载 </span>
    </p>
    </div>
  </div>
</template>
<script>

import { getHrNoticeByGuid } from "@/api/announcement.js";

export default {
  data() {
    return {
      notice: "",
      zgglk: "",
      noticeDate: "",
      atta: [],
      showWxtip:false,
    };
  },
  mounted: function () {
    if (!this.$route.query.guid) {
      //刷新页面时，无guid,调转回列表页面
      this.$router.push({
        name: "notice",
      });
      return;
    }

    window.scrollTo(0, 0);
    let Base64 = require("js-base64").Base64;
    // if (this.$route.params.datum) {
    //   if (
    //     this.$route.params.datum == "" ||
    //     this.$route.params.datum == null ||
    //     this.$route.params.datum == "0000-00-00"
    //   ) {
    //     this.noticeDate = "";
    //   } else {
    //     this.noticeDate = new Date(Date.parse(this.$route.params.datum)).format(
    //       "yyyy年MM月dd日"
    //     );
    //   }
    // }
    //读取公告附件，加載附件有些慢，所以有些數據是從前面的列表中传递过来的，这样可以加快正文的显示速度。
    //但是当页面直接刷新时，就必须从后台读了。
    getHrNoticeByGuid(this.$route.query.guid).then((response) => {
      console.log(response.data.data[0]);

      this.atta = response.data.data[0].atta; //附件
      console.log(this.atta);

      this.zgglk = response.data.data[0].zgglk; //落款
      if (
        response.data.data[0].datum == "" ||
        response.data.data[0].datum == null ||
        response.data.data[0].datum == "0000-00-00"
      ) {
        this.noticeDate = "";
      } else {
        this.noticeDate = new Date(
          Date.parse(response.data.data[0].datum)
        ).format("yyyy年MM月dd日"); //落款日期
      }

      // if (btoa(atob(this.notice)) == this.notice) {
        this.notice = Base64.decode(response.data.data[0].notic);
      // }
    });
  },
  methods: {
    downloadAttachment(item) {
      if(this.isWeixin()){
         this.showWxtip = true;
      }else{
          if (window.navigator.msSaveOrOpenBlob) {
              let blob = this.base64ToBlob(item.zhr_blob);
              window.navigator.msSaveOrOpenBlob(blob, item.filename);
          } else {
              let aLink = document.createElement("a");
              let blob = this.base64ToBlob(item.zhr_blob);
              let evt = document.createEvent("HTMLEvents");
              evt.initEvent("click", true, true);
              aLink.download = item.filename;
              aLink.href = URL.createObjectURL(blob);
              aLink.dispatchEvent(evt);
              aLink.click();
           }
      }
    },
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    closewxtip(){
      this.showWxtip = false;
    },
    isWeixin(){
      //检查是否微信
      try{
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger"){
          return true;
        }
      }catch(e){
        console.log(e);
      }
      return false;
    }
  },
};
</script>
<style scoped>
.container {
  background: rgb(243, 243, 243);
  padding-bottom: 30px;
  height: 100%;
}
.banner {
  width: 100%;
  height: 300px;
  margin-bottom: 30px;
}

.shadow-down {
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#000000,direction=120,strength=10); /*ie*/
  -moz-box-shadow: 1px 1px 10px #cacaca; /*firefox*/
  -webkit-box-shadow: 1px 1px 10px #cacaca; /*safari或chrome*/
  /* box-shadow:1px 1px 10px #cacaca; */ /*opera或ie9*/
}
.title {
  text-align: center;
  background: #fff;
  margin-top: 40px;
  margin-bottom: 40px;
}
.content {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 1000px;
  min-width: 1000px;
  background: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
}
#weixinTip{
            position:fixed;
            left:0;
            top:0;
            height:100%;
            width:100%;
            z-index:1000;
            background-color:rgba(0,0,0,0.8);
            filter:alpha(opacity=80);
                flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    }

  #weixinTip p {
            text-align:center;
        align-items: flex-end;
           color:#fff;
            font-size:2.5em;
            margin-top:50%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-content: center;
              justify-content: center;
              align-items: center;
        }
#weixinTip span{
}
#weixinTip img{

           display: block;
}

#upimg{
   position:absolute;
   right:20px;
   top:10px;
}

    .MsoNormal a{
         color:#404040;
         cursor: pointer;
     }
     .MsoNormal a:link{
         color:#404040;
         cursor: pointer;
     }
     .MsoNormal a:active{
         color:#404040;
         cursor: pointer;
     }
</style>



// WEBPACK FOOTER //
// src/views/Announcement/article.vue